<td>
    <input type="text" class="date-input" ngbDatepicker #d="ngbDatepicker" [(ngModel)]="date" id="{{product.id}}" (dateSelect)="onDateSelect($event);" />
    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>

    <button class="btn btn-color" (click)="saveDate()" title="save"><i class="bi bi-check-circle"></i></button>
</td>